import { Pagination, Select, Input } from "antd";
import { useState } from "react";
import { RightOutlined } from "@ant-design/icons";

const PageSizeOptions = [10, 20, 50, 100];

const CustomPagination = ({
  total,
  current,
  pageSize,
  onChange,
  hidePerPage,
  hideGoToPage,
  noBorder,
}) => {
  const [goPage, setGoPage] = useState("");
  const canPaginate = typeof onChange === "function";
  const safePageSize = Number(pageSize) || 1;
  const totalPages = Math.max(
    1,
    Math.ceil((Number(total) || 0) / safePageSize),
  );

  const onGoToPage = () => {
    if (!canPaginate) {
      return;
    }

    const page = Number(goPage);
    if (Number.isInteger(page) && page >= 1 && page <= totalPages) {
      onChange(page, pageSize);
      setGoPage("");
    }
  };

  return (
    <div
      className={`tw-flex tw-shrink-0 tw-text-text-primary tw-items-center tw-gap-3 tw-bg-white tw-px-4 tw-py-3.5 tw-border-t tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-slate-200 ${noBorder ? "" : "tw-border tw-border-solid tw-border-slate-200 tw-rounded-b-xl tw-mt-3 tw-shadow-sm"}`}
    >
      {/* Left - Page Size */}
      <div className="tw-min-w-[180px] tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-text-primary">
        {!hidePerPage ? (
          <>
            <span className="tw-text-[#65686F]">Showing per page</span>
            <Select
              value={pageSize}
              options={PageSizeOptions.map((v) => ({ label: v, value: v }))}
              onChange={(size) => onChange?.(1, size)}
              className="tw-w-[60px] tw-radius-[10px] tw-h-[35px] tw-text-text-primary"
              size="small"
            />
          </>
        ) : (
          <span aria-hidden />
        )}
      </div>

      {/* Center - Pagination */}
      <div className="tw-flex-1 tw-flex tw-justify-center">
        <Pagination
          current={current}
          pageSize={pageSize}
          total={total}
          onChange={onChange}
          showSizeChanger={false}
          showLessItems
          responsive
          showQuickJumper={false}
          showTitle={false}
          className="tw-flex tw-items-center tw-custom-pagination tw-text-text-primary"
        />
      </div>

      <div className="tw-min-w-[180px] tw-flex tw-items-center tw-justify-end tw-gap-2 tw-text-sm">
        {!hideGoToPage ? (
          <>
            <span className="tw-text-[#65686F]">Go to page</span>
            <Input
              size="small"
              value={goPage}
              onChange={(e) => setGoPage(e.target.value.replace(/\D/g, ""))}
              onPressEnter={onGoToPage}
              className="tw-w-[56px] tw-radius-[10px] tw-h-[32px] tw-text-text-primary"
            />
            <button
              type="button"
              disabled={!goPage || !canPaginate}
              onClick={onGoToPage}
              className={`tw-border-0 tw-flex tw-items-center tw-gap-1 tw-bg-transparent tw-text-text-primary tw-font-medium ${!goPage || !canPaginate ? "tw-cursor-not-allowed" : "tw-cursor-pointer"}`}
            >
              Go
              <RightOutlined />
            </button>
          </>
        ) : (
          <span aria-hidden />
        )}
      </div>
    </div>
  );
};

export default CustomPagination;
